<template>
  <div class="fa">
    <el-dialog title="选择店铺" :show-close="false" width="40%" :visible.sync="dialogFormVisible" :lock-scroll="true"
      :close-on-click-modal="false">
      <div :class="scroll_father == 'scroll-father' ? 'box' : 'box-small'" :style="feed == false
        ? 'border:1px solid #ccc;border-radius:5px'
        : ''
        ">
        <div>
          <div style="height: 40px; " class="top-title">
            <!-- h1 -->
            修改进件信息

          </div>
          <div :class="scroll_father" style="">
            <el-scrollbar wrapStyle="overflow-x:hidden;" style="height: 100%">
              <el-divider content-position="left">
                <h2>资质信息</h2>
              </el-divider>
              <el-form label-width="180px" label-position="right" class="form-one">
                <el-form-item style="margin-top: 30px" label="店铺密码：">{{
                  shop_info.pass_word
                }}</el-form-item>
                <el-form-item label="营业执照照片：">
                  {{ shop_info.img_license }}

                  <!-- <img :src="shop_info.img_license
                      ? $url +
                      'media/image/' +
                      shop_info.img_license +
                      '.jpg'
                      : ''
                      " style="height: 660px; width: 450px" alt="" v-show="shop_info.img_license" /> -->
                </el-form-item>
                <el-form-item label="店铺名称：">{{
                  shop_info.mch_name
                }}</el-form-item>
                <el-form-item label="店铺名称：">{{
                  shop_info.sub_name
                }}</el-form-item>
                <el-form-item label="营业执照id：">{{
                  shop_info.license_code
                }}</el-form-item>
                <el-form-item label=" 营业执照有效期：">{{ shop_info.license_start_date }}到{{
                  shop_info.license_expire_in
                    ? shop_info.license_expire_in
                    : ""
                }}</el-form-item>
                <el-form-item label="店铺地址：">{{
                  shop_info.address
                }}</el-form-item>

                <!-- <el-form-item label="商户类型：">
                    {{ getMchType() }}
                  </el-form-item>
                  <el-form-item label="经营范围：">
                    {{ getBusinessScope() }}
                  </el-form-item> -->

                <el-form-item label="店铺省市区：">{{
                  shop_info.address_name
                }}</el-form-item>

                <el-form-item label="店铺门头照：">
                  {{ shop_info.img_door }}
                  <!-- <img :src="shop_info.img_door
                      ? $url + 'media/image/' + shop_info.img_door + '.jpg'
                      : ''
                      " style="height: 400px; width: 586px" v-show="shop_info.img_door" alt="" /> -->
                </el-form-item>

                <el-form-item label="店铺内景照片：">
                  {{ shop_info.img_in_door }}

                  <!-- <img :src="shop_info.img_in_door
                      ? $url +
                      'media/image/' +
                      shop_info.img_in_door +
                      '.jpg'
                      : ''
                      " style="height: 400px; width: 586px" alt="" v-show="shop_info.img_in_door" />-->
                </el-form-item>
                <el-form-item label="收银台照片：">
                  {{ shop_info.img_cashier }}

                  <!-- <img :src="shop_info.img_cashier
                      ? $url +
                      'media/image/' +
                      shop_info.img_cashier +
                      '.jpg'
                      : ''
                      " style="height: 400px; width: 586px" v-show="shop_info.img_cashier" alt="" /> -->
                </el-form-item>
              </el-form>
              <el-divider content-position="left">
                <h2>基础信息</h2>
              </el-divider>
              <el-form label-width="180px" label-position="right" ref="wxFormRef" class="form-one">
                <el-form-item label="法人身份证正面：">
                  {{ shop_info.img_legal_id_front }}

                  <!-- <img :src="shop_info.img_legal_id_front
                      ? $url +
                      'media/image/' +
                      shop_info.img_legal_id_front +
                      '.jpg'
                      : ''
                      " style="height: 225px; width: 330px" v-show="shop_info.img_legal_id_front" alt="" />
                    <img :src="shop_info.img_legal_id_back
                      ? $url +
                      'media/image/' +
                      shop_info.img_legal_id_back +
                      '.jpg'
                      : ''
                      " style="height: 225px; width: 330px" v-show="shop_info.img_legal_id_back" alt="" /> -->
                </el-form-item>
                <el-form-item label="法人身份证反面：">{{
                  shop_info.img_legal_id_front
                }}</el-form-item>
                <el-form-item label="法人姓名：">{{
                  shop_info.legal_person_name
                }}</el-form-item>
                <el-form-item label="法人身份证号：">{{
                  shop_info.legal_person_id
                }}</el-form-item>

                <el-form-item label="法人身份证有效期：">
                  {{ shop_info.legal_person_id_start_date }}到{{
                    shop_info.legal_person_id_expire_in
                  }}
                </el-form-item>
                <!-- <el-form-item label="联系人：">{{
                    shop_info.contact_man
                  }}</el-form-item> -->
                <el-form-item label="联系人手机号：">{{
                  shop_info.mobile_no
                }}</el-form-item>
                <el-form-item label="店铺电话：">{{
                  shop_info.phone
                }}</el-form-item>
                <el-form-item label="服务电话：">{{
                  shop_info.service_phone
                }}</el-form-item>
                <el-form-item label="店铺传真：">{{
                  shop_info.fax
                }}</el-form-item>
                <el-form-item label="店铺邮箱：">{{
                  shop_info.e_mail
                }}</el-form-item>
              </el-form>
              <el-divider content-position="left">
                <h2>结算信息</h2>
              </el-divider>
              <el-form label-width="180px" label-position="right：" ref="wxFormRef" class="form-one">
                <el-form-item label="开户银行卡照片：">
                  {{ shop_info.img_bank_card }}
                  <!-- <img :src="shop_info.img_bank_card
                      ? $url +
                      'media/image/' +
                      shop_info.img_bank_card +
                      '.jpg'
                      : ''
                      " style="height: 400px; width: 586px" v-show="shop_info.img_bank_card" alt="" /> -->
                </el-form-item>
                <el-form-item label="结算银行卡号：">{{
                  shop_info.account_code
                }}</el-form-item>
                <el-form-item label="银行卡账号名称：">{{
                  shop_info.account_name
                }}</el-form-item>
                <!-- <el-form-item label="银行名称：">{{
                    shop_info.bank_name
                  }}</el-form-item>
                  <el-form-item label="开户银行名称：">{{
                    shop_info.open_bank_name
                  }}</el-form-item> -->
                <el-form-item label="开户银行银联号：">{{
                  shop_info.open_bank_code
                }}</el-form-item>

                <el-form-item label="服务费率：">
                  {{ shop_info.service_charge }}
                </el-form-item>
                <el-form-item label="结算方式：">{{ shop_info.wxradio === '1' ? "法人结算" : shop_info.wxradio ===
                  '2' ? "非法人结算" : "对公结算" }}
                </el-form-item>
                <el-form-item label="结算人身份证正面：">
                  {{ shop_info.img_beneficiary_id_front }}
                  <!-- <img :src="shop_info.img_beneficiary_id_front
                      ? $url +
                      'media/image/' +
                      shop_info.img_beneficiary_id_front +
                      '.jpg'
                      : ''
                      " style="height: 225px; width: 330px" v-show="shop_info.img_beneficiary_id_front" alt="" /> -->
                  <!-- <img :src="shop_info.img_beneficiary_id_back
                      ? $url +
                      'media/image/' +
                      shop_info.img_beneficiary_id_back +
                      '.jpg'
                      : ''
                      " style="height: 225px; width: 330px" v-show="shop_info.img_beneficiary_id_back" alt="" /> -->
                </el-form-item>
                <el-form-item label="结算人身份证反面：">
                  {{ shop_info.img_beneficiary_id_back }}
                </el-form-item>
                <el-form-item label="受益人姓名：">
                  {{ shop_info.beneficiary_name }}
                </el-form-item>
                <el-form-item label="受益人身份证号：">{{
                  shop_info.beneficiary_id
                }}</el-form-item>
                <el-form-item label="受益人人身份证有效期：">
                  {{ shop_info.beneficiary_id_start_date }}到{{
                    shop_info.beneficiary_id_expire_in
                  }}
                </el-form-item>

                <el-form-item v-if="shop_info.wxradio === '2'" label="授权书：">
                  {{ shop_info.img_warrant }}
                  <!-- <img :src="shop_info.img_warrant
                      ? $url +
                      'media/image/' +
                      shop_info.img_warrant +
                      '.jpg'
                      : ''
                      " style="height: 400px; width: 586px" v-show="shop_info.img_warrant" alt="" /> -->
                </el-form-item>
              </el-form>
            </el-scrollbar>
          </div>
        </div>
        <div :class="scroll_father == 'scroll-father'
          ? 'button-bottom'
          : 'button-bottom-small'
          ">
          <!-- :size="scroll_father == 'scroll-father-small' ? 'small' : ''" -->
          <el-button size="small" plain type="primary" @click="submitInfo">保存更改</el-button>
          <el-button v-if="feed == false" size="small" plain type="danger" @click="closeMorf">关闭</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
/* import {
  GetBankProvince,
  GetBankcity,
  GetBankCode,
  merchantQuery,
  queryMerchant,
  merchantModify,
  ModifyMerchant,
  GetMrchantAesKey
} from "@/api/index"; */
//import uploadImg from "../components/uploadImg.vue";
export default {
  name: "morf",
  async created() {
    /* this.provincearr = province;
    this.map = map;
    this.MCC = MCC;
    var { data: res } = await GetBankProvince();
    for (var i = 0; i < res.resp_data.length; i++) {
      this.province_option.push({
        label: res.resp_data[i],
        value: i
      });
    } */
  },
  async mounted() {
    var resolution = localStorage.getItem("pixel");
    if (resolution <= 1400 * 900) {
      this.scroll_father = "scroll-father-small";
    }
    if (resolution > 1400 * 900) {
      this.scroll_father = "scroll-father";
    }
    console.log("true:为 店铺 false：为服务商", this.feed);

    /*  if (this.feed) {
      var data = {
        access_token: localStorage.getItem("access_token")
      };
      this.$nextTick(function () {
        merchantQuery(data).then(async ({ data: res }) => {
          GetMrchantAesKey().then(({ data: resk }) => {
            if (res.resp_data.legal_person_id) {
              res.resp_data.legal_person_id = that.Decrypt(
                res.resp_data.legal_person_id,
                resk.resp_data.aes_key
              );
            }
            if (res.resp_data.beneficiary_id) {
              res.resp_data.beneficiary_id = that.Decrypt(
                res.resp_data.beneficiary_id,
                resk.resp_data.aes_key
              );
            }
            if (res.resp_data.mobile_no) {
              res.resp_data.mobile_no = that.Decrypt(
                res.resp_data.mobile_no,
                resk.resp_data.aes_key
              );
            }
            console.log("解密mobile_no：", res.resp_data.mobile_no);
            console.log("密钥：", resk.resp_data.aes_key);

            for (var key in res.resp_data) {
              if (key == "is_pre_auth") {
                this[key] = Number(res.resp_data[key]);
              } else if (key == "mch_type") {
                for (var i = 0; i < this.mch_type_options.length; i++) {
                  if (
                    this.mch_type_options[i].value == String(res.resp_data[key])
                  );
                  this.mch_type_name = this.mch_type_options[i].label;
                }
              } else if (key == "state") {
                this[key] = Number(res.resp_data[key]);
              } else if (key == "beneficiary_id_expire_in") {
                this.beneficiary_id_expire_in = res.resp_data[key];
              } else {
                this[key] = res.resp_data[key];
              }
            }
          });
          console.log(res.resp_data);
        });
      });
    } else {
      var data = {
        merchant_id: this.mch_id,
        access_token: localStorage.getItem("access_token")
      };
      var { data: res } = await queryMerchant(data);
      for (var key in res.resp_data) {
        if (key == "is_pre_auth") {
          this[key] = Number(res.resp_data[key]);
        } else if (key == "mch_type") {
          for (var i = 0; i < this.mch_type_options.length; i++) {
            if (this.mch_type_options[i].value == String(res.resp_data[key]));
            this.mch_type_name = this.mch_type_options[i].label;
          }
        } else if (key == "state") {
          this[key] = Number(res.resp_data[key]);
        } else if (key == "beneficiary_id_expire_in") {
          this.beneficiary_id_expire_in = res.resp_data[key];
        } else {
          this[key] = res.resp_data[key];
        }
      }
    } */
  },
  beforeDestroy() { },
  data() {
    return {
      //类
      scroll_father: "",
      //是否显示
      dialogFormVisible: true,
      shop_info: {
        //店铺类型
        mch_type: 1,
        //省市区编号
        address_code: "",
        /// 店铺密码
        pass_word: "123",
        merchant_industry: 1,
        /// 店铺全名称 优选易购生活超市-颐和店
        mch_name: "",
        /// 营业执照ID
        license_code: "",
        /// 法人姓名
        legal_person_name: "",
        /// 法人身份证号
        legal_person_id: "",
        /// 联系人 日常联系人通常是业务员
        contact_man: "",
        /// 联系人的手机号码
        mobile_no: "",
        /// 店铺地址
        address: "",
        /// 店铺电话
        phone: "",
        /// 服务电话 给用户联系的电话展示在店铺中
        service_phone: "",
        /// 传真
        fax: "",
        /// 电子邮箱
        e_mail: "",
        /// 结算银行卡的账号名称
        account_name: "",
        /// 结算账号
        account_code: "",
        //开户银行
        bank_name: "",
        //开户银行名称含支行
        open_bank_name: "",
        ///银行卡
        img_bank_card: "",
        ///门头照
        img_door: "",
        //内景
        img_in_door: "",
        //收银台
        img_cashier: "",
        //授权书
        img_warrant: "",
        /// 法人身份证正面人像面
        img_legal_id_front: "",
        /// 法人身份证反面
        img_legal_id_back: "",
        /// 营业执照照片
        img_license: "",
        //受益人
        beneficiary_name: "",
        beneficiary_id: "",
        img_beneficiary_id_front: "", //正面
        img_beneficiary_id_back: "", //反面
        //受益人身份证开始日期截止日期
        beneficiary_id_start_date: "",
        beneficiary_id_expire_in: "",

        //商铺类型
        merchant_type: "",
        //经营范围
        business_scope: "",

        //营业执照开始有效期
        license_start_date: "",
        //营业执照结束有效期
        license_expire_in: "",

        //法人身份证开始有效期
        legal_person_id_start_date: "",
        //法人身份证结束有效期
        legal_person_id_expire_in: "",

        //服务费率
        service_charge: "",
        //是否预授权
        is_pre_auth: 2,
        //开户行银联号
        open_bank_code: "",
        wxradio: "1",
        //开户银行省不是必要字段
        bank_province: ""
      }
    };
  },
  props: {
    feed: Boolean,
    mch_id: String
  },
  methods: {
    getOpenBnakName() {
      for (var i = 0; i < this.open_bank_options.length; i++) {
        if (this.open_bank_options[i].label === this.open_bank_name) {
          this.open_bank_code = this.open_bank_options[i].value;
        }
      }
    },
    getReturn(res) {
      switch (res.title) {
        case "beneficiary_zm":
          if (res.img) {
            this.img_beneficiary_id_front = res.img;
          }
          if (res.img_info) {
            // console.log("受益人身份证正面：",res.img_info)
            this.beneficiary_name = res.img_info.name;
            this.beneficiary_id = res.img_info.number;
          } else {
            this.warnMessage("受益人身份证正面上传失败，请重试");
          }
          break;
        case "zm":
          if (res.img_info) {
            /* this.legal_person_card = res.info;
            this.legal_person_name = res.info;
            this.contact_man = res.info; */
            this.legal_person_name = res.img_info.name;
            this.legal_person_id = res.img_info.number;
          }
          if (res.imgstr) {
            this.legal_person_img_font = res.imgstr;
          }
          break;
        case "beneficiary_fm":
          if (res.img) {
            this.img_beneficiary_id_back = res.img;
          }
          if (res.img_info) {
            this.beneficiary_id_start_date = res.img_info.begin;
            this.beneficiary_id_expire_in = res.img_info.end;
          } else {
            this.warnMessage("受益人身份证反面上传失败，请重试");
          }
          break;
        case "fm":
          if (res.img_info) {
            this.legal_person_id_start_date = res.img_info.begin;
            this.legal_person_id_expire_in = res.img_info.end;
          }
          if (res.imgstr) {
            this.legal_person_img_back = res.imgurl;
          }
          break;
        case "bank":
          if (res.img_info) {
            this.account_code = res.img_info.number;
          }
          if (res.imgstr) {
            this.bank_img = res.imgstr; //银行卡照片
          }
          break;
      }
    },
    // 提交信息
    async submitInfo() {

    },
    closeMorf() {
      this.$emit("colse-morf", "");
    }
  }
};
</script>
<style scoped>

.top-title {
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: left;
  font-size: 24px;
  font-weight: 700;
  padding-left: 20px;
  color: #409eff;
}

.scroll-father {
  height: 620px;
}

.scroll-father-small {
  height: 550px;
}

.el-form-item>>>.el-input {
  width: 460px;
}

.button-bottom-small {
  position: absolute;
  /* bottom: 30px; */
  left: 50%;
  transform: translate(-50%, 0);
  display: flex;
  justify-content: space-between;
}

.button-bottom {
  position: absolute;
  bottom: 1px;
  left: 50%;
  transform: translate(-50%, 0);
  display: flex;
  justify-content: space-between;
}

h2 {
  margin: 0;
  padding: 0;
}

#bank_select>>>.el-input {
  width: 150px !important;
}

.box {
  position: fixed;
  width: 962px;
  height: 702px;
  top: 53%;
  left: 50%;
  transform: translate(-50%, -50%);
  margin-top: -20px;
  background-color: #fff !important;
}

.box-small {
  position: fixed;
  width: 962px;
  height: 650px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  margin-top: -20px;
  background-color: #fff !important;
}

img {
  font-size: 20px;
  color: rgb(175, 26, 26);
}

.el-form-item {
  color: rgb(113, 113, 113);
  margin-bottom: 10px;
}
</style>
